/* NewEden2.0 — recently-viewed.js
   Stores recently viewed product handles in localStorage and renders them
   into a [data-recently-viewed] container using Shopify product JSON.
   (localStorage is fully supported in a live Shopify storefront.) */
(function () {
  'use strict';
  if (window.NovaRecentlyViewedLoaded) return;
  window.NovaRecentlyViewedLoaded = true;
  var KEY = 'neweden:recently-viewed';
  var MAX = 12;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX))); } catch (e) {}
  }

  // Track current product (set on PDP via a meta tag rendered by the section)
  var meta = document.querySelector('[data-current-product-handle]');
  if (meta) {
    var handle = meta.getAttribute('data-current-product-handle');
    if (handle) {
      var list = read().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      write(list);
    }
  }

  function renderContainer(container) {
    var isEnglish = document.documentElement.lang && document.documentElement.lang.toLowerCase().indexOf('en') === 0;
    var localeRoot = isEnglish ? '/en' : '';
    function localizedProductUrl(url) {
      if (!isEnglish || !url || url === '/en' || url.indexOf('/en/') === 0) return url;
      return localeRoot + url;
    }
    var currentHandle = container.getAttribute('data-exclude') || (meta && meta.getAttribute('data-current-product-handle'));
    var handles = read().filter(function (h) { return h !== currentHandle; });
    var limit = parseInt(container.getAttribute('data-limit') || '4', 10);
    handles = handles.slice(0, limit);
    if (!handles.length) { container.closest('[data-recently-viewed-section]') && (container.closest('[data-recently-viewed-section]').hidden = true); return; }

    var grid = container.querySelector('[data-recently-viewed-grid]') || container;
    Promise.all(handles.map(function (h) {
      return fetch(localeRoot + '/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var html = products.filter(Boolean).map(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var price = window.NewEden ? window.NewEden.formatMoney(p.price) : (p.price / 100).toFixed(2);
        return '<article class="product-card product-card--mini">' +
          '<a href="' + localizedProductUrl(p.url) + '" class="product-card__media">' +
          (img ? '<img src="' + img + '&width=400" alt="' + (p.title || '') + '" width="400" height="500" loading="lazy" decoding="async">' : '') +
          '</a><div class="product-card__info">' +
          '<h3 class="product-card__title"><a href="' + localizedProductUrl(p.url) + '">' + p.title + '</a></h3>' +
          '<span class="price">' + price + '</span></div></article>';
      }).join('');
      if (html) {
        grid.innerHTML = html;
        var section = container.closest('[data-recently-viewed-section]');
        if (section) section.hidden = false;
      }
      else { var sec = container.closest('[data-recently-viewed-section]'); if (sec) sec.hidden = true; }
    });
  }

  function renderAll() {
    var containers = document.querySelectorAll('[data-recently-viewed]');
    if (!containers.length) return;
    containers.forEach(renderContainer);
  }

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(renderAll, { timeout: 2000 });
  } else {
    window.setTimeout(renderAll, 1200);
  }
})();
